import { useAuthStore } from '../stores/auth.store';

export function usePermissions() {
  const { user, customer } = useAuthStore();

  const hasRole = (role: string) => user?.roles?.includes(role) ?? false;

  return {
    // Role checks
    isGlobalAdmin: hasRole('GlobalAdmin'),
    isUserAdmin: hasRole('UserAdmin') || hasRole('GlobalAdmin'),
    isLicenseAdmin: hasRole('LicenseAdmin') || hasRole('GlobalAdmin'),
    isCustomerAdmin: hasRole('CustomerAdmin') || hasRole('GlobalAdmin'),
    isProgramAdmin: hasRole('ProgramAdmin') || hasRole('CustomerAdmin') || hasRole('GlobalAdmin'),

    // Permission checks
    canManageAllCustomers: hasRole('GlobalAdmin'),
    canManageGlobalRoles: hasRole('GlobalAdmin') || hasRole('UserAdmin'),
    canManageLicenses: hasRole('LicenseAdmin') || hasRole('GlobalAdmin'),
    canManageCustomerUsers: hasRole('CustomerAdmin') || hasRole('ProgramAdmin') || hasRole('GlobalAdmin'),
    canAccessAdminPanel: hasRole('GlobalAdmin') || hasRole('UserAdmin') || hasRole('LicenseAdmin') || hasRole('CustomerAdmin') || hasRole('ProgramAdmin'),

    // Context
    currentCustomerId: customer?.id,
    hasRole,
  };
}

export default usePermissions;
